import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-team-game-list',
    templateUrl: './team-game-list.component.html',
    styleUrls: ['./team-game-list.component.css']
})
export class TeamGameListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
